import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=3e44e789&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=ts&"
export * from "./manage.vue?vue&type=script&lang=ts&"
import style0 from "./manage.vue?vue&type=style&index=0&id=3e44e789&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e44e789",
  null
  
)

export default component.exports